import { AccountNumberRegistrationEvent } from './AccountNumberRegistrationEvent';

export class AccountNumberRegistrationRemovedEvent extends AccountNumberRegistrationEvent {}
